<h1>{{ (organisation | async)?.name }}</h1>
<div fxLayout="row"
  fxLayoutGap="80px">

  <div fxFlex="1 1 35%">
    <h2>Organisation Details</h2>
    <organisation-form *ngIf="organisation | async"
      [mode]="formMode"
      (submitted)="saveOrganisation($event)"
      [organisation]="organisation | async"></organisation-form>

  </div>

  <div fxFlex="1 1 65%">
    <h2>Message Categories</h2>
    <memo-categories-table (remove)="removeCategory($event)"
      (save)="saveCategory($event)"
      [categories]="categories$ | async">
    </memo-categories-table>

    <ca-autocomplete-search [formControl]="category"
      [items]="allCategories$ | async"
      [render]="renderCategory"
      [filter]="filterCategory"></ca-autocomplete-search>
    <button mat-flat-button
      (click)="addCategory()">Add</button>

    <h2>Invite Users</h2>
    <ca-invite *ngIf="!(sent | async)"
      (invite)="invite($event)"
      [disabled]="loading | async"
      [error]="error | async"
      [loading]="loading | async"
      [roleOptions]="roles">
    </ca-invite>
    <ca-sent-reset [sent]="sent | async"
      (reset)="resetInvite()"></ca-sent-reset>
  </div>

</div>